import { Entity, makeClone } from 'gossamer-unified';
import { OrgUnitMember } from './OrgUnitMember';

export interface OrgUnitMemberViewRow {
  id: number;
  org_unit_id: number;
  created_at: string;
  user_id: string;
  is_admin: boolean;
  is_verified: boolean;
}

const clone = makeClone();

export const OrgUnitMemberView: Entity<OrgUnitMemberViewRow> = {
  id: 'OrgUnitMemberView',
  title: 'Org Unit Member View',
  service: 'main',
  rowLabel: (row: OrgUnitMemberViewRow) => [row.org_unit_id, row.user_id].join(' / '),
  rowLabelDynamic: (row: OrgUnitMemberViewRow) => `<lookup:OrgUnit:${row.org_unit_id}> / <lookup:User:${row.user_id}>`,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.org_unit_member_view',
  },
  security: [
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: 'institution_id = {adminInstitutionId}',
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['org_unit_id', 'ASC']],
  defaultFilters: [{ fieldId: 'org_unit_id', operator: 'eq', value: '' }],
  fields: {
    id: clone(OrgUnitMember.fields.id),
    org_unit_id: clone(OrgUnitMember.fields.org_unit_id),
    user_id: clone(OrgUnitMember.fields.user_id, { listColumn: false }),
    created_at: clone(OrgUnitMember.fields.created_at),
    is_admin: clone(OrgUnitMember.fields.is_admin),
    is_verified: clone(OrgUnitMember.fields.is_verified),
  },
};
